import { GET_ACTIVE_DELEGATIONS } from "../../../../enums/MyDivision/Delegation/AuthorityDelegation.types";

export const getActiveDelegationsActions = (data) => {
    return {
        type: GET_ACTIVE_DELEGATIONS,
        payload: data,
    }
}
